'use strict';

import controller from './modulo.controller';
import template from './modulo.html';

const ModuloComponent = {
  bindings:{
    modulo: '=',
    proyecto: '<',
    modoVista: '<',
    callback: '&',
    options: '<'
  },
  controller,
  template
};

export default ModuloComponent;



// WEBPACK FOOTER //
// ./src/app/components/empresas/modificacion/nuevomodulo/modulo.component.js